export const GET_ALL_EVENTS = 'action/event/all/get'
export const GET_ALL_EVENTS_BY_COMPETENCES = 'action/event/all/by-competences/get'
export const SAVE_EVENT = 'action/event/post'
export const ACTIVATE_EVENT = 'action/event/activate'
export const DEACTIVATE_EVENT = 'action/event/deactivate'
export const DELETE_EVENT = 'action/event/delete'
export const BOOKMARK_EVENT = 'action/event/bookmark'
export const GET_BOOKMARK_EVENTS = 'action/event/bookmark/get'
export const GET_ALL_TOPICS = 'action/event/topics/get'
